import axios from '@/components/api/axios';

async function getBankAccount() {
  const res = await axios.axiosGet('/api/bankAccounts/getOne', null);
  return res;
}

async function updateBankAccount(data) {
  const res = await axios.axiosPut('/api/bankAccounts/update', data);
  return res;
}


export default {
  getBankAccount,
  updateBankAccount
}



// WEBPACK FOOTER //
// ./src/components/api/bankAccount.js